import styled from 'styled-components'
import { colors, screenSizes } from 'styles/theme'

export const ScrollCardCont = styled.div`
  width: 150px !important;
  height: 150px;
  user-select: 'none';
  position: relative;
  margin: 0 auto;
  border: 2px solid ${colors.white};

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 0;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  @media (min-width: ${screenSizes.XS}px) {
    width: 220px !important;
    height: 220px;
  }
`
